module.exports = __webpack_public_path__ + "static/media/ots.f5bce660.png";